export const GIS_LAND_USE = {
  RESIDENTIAL_AREA: 'Residential area',
  AGRICULTURE_AREA: 'Agriculture area',
  PUBLIC_AREA: 'Public area',
  NO_MAN_AREA: 'No man area',
};
